import React, { useState } from "react";
// import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import useAdminUserFetch from "../useAdminUserFetch";

function ConfirmHardDelete({ open, onClose, userId, onDeleted }) {
  const { deleteUser, isDeletingUser } = useAdminUserFetch();

  if (!open) return null;

  const handleDelete = () => {
    deleteUser(userId);
    if (onDeleted) onDeleted();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-8 relative animate-fade-in">
        <div className="flex flex-col items-center text-center">
          {/* <ExclamationTriangleIcon
            className="h-16 w-16 text-red-500 mb-4"
            aria-hidden="true"
          /> */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            className="h-16 w-16 text-red-500 mb-4"
          >
            <g
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            >
              <path
                strokeWidth={1.5}
                d="M10.367 4.462L2.752 17.655a1.885 1.885 0 0 0 1.634 2.827h15.228a1.885 1.885 0 0 0 1.633-2.827L13.633 4.462a1.885 1.885 0 0 0-3.266 0m1.628 3.116v6.277"
              ></path>
              <path strokeWidth={2} d="M12.043 17.326h-.009"></path>
            </g>
          </svg>
          <h2 className="text-xl font-bold text-red-700 mb-2">
            Permanently Delete User?
          </h2>
          <p className="text-gray-700 mb-4">
            <span className="font-semibold text-red-600">Warning:</span> This
            action <span className="font-bold">cannot be undone</span>.<br />
            All user data, order history, and related information will be{" "}
            <span className="font-bold">permanently removed</span> from the
            system.
            <br />
            Please ensure you have reviewed this user's data and understand the
            consequences before proceeding.
          </p>
          <div className="flex gap-4 w-full mt-2">
            <button
              onClick={handleDelete}
              disabled={isDeletingUser}
              className="flex-1 bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-md transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {isDeletingUser ? "Deleting..." : "Yes, Delete Permanently"}
            </button>
            <button
              onClick={onClose}
              disabled={isDeletingUser}
              className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded-md transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmHardDelete;
